<template>
    <div class="shop-details-page">
        <!-- 头部组件 -->
        <Header />
        <div>
            <!-- 顶部导航路径 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{
                        name: 'home', params: {
                            activeName: '2',
                        },
                    }">供应大厅</el-breadcrumb-item>
                    <el-breadcrumb-item>商品详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 商品信息主体 -->
            <div class="shop-details-main">
                <div class="container">
                    <div class="main-content">
                        <!-- 左侧图片区域 -->
                        <div class="left-section">
                            <!-- 主图展示 -->
                            <div class="main-image">
                                <el-image :src="url" :preview-src-list="shopInfo.images">
                                </el-image>
                            </div>
                            <!-- 缩略图列表 -->
                            <div class="thumbnail-list">
                                <div class="thumbnail-item" v-for="(item, index) in shopInfo.images" :key="index">
                                    <el-image style="width: 100px; height: 100px" :src="item"
                                        :preview-src-list="shopInfo.images">
                                    </el-image>
                                </div>
                            </div>
                            <!-- 图片操作按钮 -->
                            <div class="image-actions">
                                <el-button type="text" size="medium" @click="collectFn(1)"
                                    v-if="shopInfo.is_collect == 0">
                                    <i class="el-icon-star-off"></i> 收藏
                                </el-button>
                                <el-button type="text" size="medium" @click="collectFn(2)" v-else>
                                    <i class="el-icon-star-on"></i> 已收藏
                                </el-button>
                                <el-button type="text" size="medium" @click="copyCurrentUrl">
                                    <i class="el-icon-share"></i> 分享
                                </el-button>
                                <el-button type="text" size="medium">
                                    <i class="el-icon-warning"></i> 举报
                                </el-button>
                            </div>
                        </div>

                        <!-- 中间商品信息区域 -->
                        <div class="middle-section">
                            <!-- 商品标题 -->
                            <div class="title-section">
                                <h1 class="product-title">
                                    {{ shopInfo.name }}
                                </h1>
                                <!-- <p class="product-subtitle">
                                    2024年霜冻后应控种植怀山荮，无膨大剂，同时供应山荮粉，山药片
                                </p> -->
                            </div>

                            <!-- 价格信息 -->
                            <div class="price-section">
                                <div class="price-label">价格</div>
                                <div class="price-value">{{ shopInfo.shop_price }}元</div>
                            </div>

                            <!-- 销量和发货地信息 -->
                            <div class="info-row">
                                <div class="sales-info">
                                    <span class="info-label">销量</span>
                                    <span class="info-value">{{ shopInfo.sales_sum }}</span>
                                </div>
                                <div class="shipping-info">
                                    <span class="info-label">发货地</span>
                                    <span class="info-value">{{ shopInfo.place_of_dispatch }}</span>
                                </div>
                            </div>

                            <!-- 规格选择 -->
                            <div class="specification">
                                <div class="spec-label">规格</div>
                                <div class="spec-options">
                                    <div class="spec-item" v-for="(item, index) in shopInfo.sku_list" :key="index">
                                        <span class="spec-name">{{ item.key_name }}</span>
                                        <span class="spec-price">￥{{ item.shop_price }}/{{ item.unit }}</span>
                                        <span class="spec-min">{{ item.min_buy_num }}{{ item.unit }}起批</span>
                                    </div>

                                </div>
                            </div>

                            <!-- 购买按钮 -->
                            <div class="purchase-buttons">
                                <el-button type="primary" size="large" class="buy-button"
                                    @click="dialogVisible = true">立即购买</el-button>
                                <el-button type="default" size="large" class="contact-button"
                                    @click="goChat">在线沟通</el-button>
                            </div>
                        </div>

                        <!-- 右侧商家信息区域 -->
                        <div class="right-section">
                            <div class="merchant-info">
                                <div class="merchant-logo">
                                    <img :src="shopInfo.shop_info.store_logo" alt="商家logo">
                                </div>
                                <div class="merchant-name">{{ shopInfo.shop_info.store_name }}</div>
                                <div class="merchant-rating">
                                    <el-rate disabled v-model="shopInfo.shop_info.store_star"
                                        score-template="{value}"></el-rate>
                                    <span class="rating-text">{{ shopInfo.shop_info.store_collection_num }}人关注</span>
                                </div>
                                <div class="merchant-buttons">
                                    <el-button type="default" class="enter-shop"
                                        @click="toStoreDetails(shopInfo.shop_info.store_id)">进店逛逛</el-button>
                                    <el-button type="primary" class="follow-shop" @click="guanzhuFn"
                                        v-if="shopInfo.shop_info.is_attent == 0">关注店铺</el-button>
                                    <el-button type="primary" class="follow-shop" @click="cancleGuanzhuFn"
                                        v-if="shopInfo.shop_info.is_attent == 1">取消关注</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 商品详情标签页 -->
            <div class="product-details-tabs">
                <div class="container tab-container">
                    <el-tabs v-model="activeTab" class="details-tabs">
                        <el-tab-pane label="商品详情" name="details">
                            <div class="tab-content">
                                <!-- <h3>商品详情</h3> -->
                                <div class="details-content" v-html="shopInfo.body">

                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="'评价 (' + shopInfo.comment_total + ')'" name="comments">
                            <div class="tab-content">
                                <!-- 评价统计筛选栏 -->
                                <div class="comments-filter">
                                    <!-- <div class="filter-item active">全部 <span class="filter-count">9999+</span></div> -->
                                    <div class="filter-item" :class="{ 'active': pingjiaTabs == index }"
                                        v-for="(item, index) in commentTabs" :key="index"
                                        @click="changeTab(item.type_name, index)">{{
                                            item.type_title }}
                                        <span class="filter-count">{{
                                            item.type_count }}</span>
                                    </div>
                                </div>
                                <!-- 评价列表 -->
                                <div class="comments-content">
                                    <!-- <p>暂无评价</p> -->
                                    <!-- 第一个评价 -->
                                    <div class="comment-item" v-for="(item, index) in commentList" :key="index">
                                        <div class="comment-header">
                                            <div class="user-info">
                                                <div class="user-avatar">
                                                    <img :src="item.avatar" alt="用户头像">
                                                </div>
                                                <div class="user-name">{{ item.nickname }}</div>
                                            </div>
                                            <div class="comment-time">{{ item.create_time }}</div>
                                        </div>
                                        <div class="comment-content">
                                            <p>{{ item.content }}</p>
                                        </div>
                                        <div class="comment-images">
                                            <div class="comment-image-item" v-for="(ele, index1) in item.thumb"
                                                :key="index1">
                                                <el-image :src="ele" :preview-src-list="item.thumb">
                                                </el-image>
                                            </div>

                                        </div>
                                        <div class="comment-spec-rating">
                                            <div class="comment-spec">
                                                规格：{{ item.sku_name }}
                                            </div>
                                            <div class="comment-rating">
                                                <div class="comment-spec-stars">
                                                    评价星级：
                                                </div>
                                                <el-rate disabled v-model="item.star" :max="5"
                                                    score-template="{value}"></el-rate>
                                            </div>
                                        </div>
                                    </div>


                                    <!-- 分页控件 -->
                                    <div class="pagination-container">
                                        <el-pagination @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange" :current-page="currentPage"
                                            :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                                            layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="温馨提示" name="tips">
                            <div class="tab-content">
                                <div class="tips-content">
                                    <!-- 温馨提示内容将在这里显示 -->
                                    <p v-if="!shopInfo.warm_prompt">暂无温馨提示</p>
                                    <div class="details-content" v-else>
                                        <p>{{ shopInfo.warm_prompt }}</p>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

        </div>

        <!-- 底部组件 -->
        <Footer />


        <!-- 下单弹窗 -->
        <el-dialog title="下单" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
            <div class="dialog-content">
                <div class="dialog-content-top">
                    <img :src="url" alt="">
                    <span>
                        {{ shopInfo.name }}
                    </span>
                </div>
            </div>

            <div class="dialog-guige" v-for="(item, index) in shopInfo.sku_list" :key="index">
                <div class="dialog-guige-left">
                    <div class="dialog-guige-left-checkbox">
                        <el-checkbox v-model="item.checked" @change="handleCheckboxChange(item)"></el-checkbox>
                        <div class="dialog-guige-left-name">{{ item.key_name }}</div>
                    </div>
                    <div class="dialog-guige-left-price">￥{{ item.shop_price }}/{{ item.unit }}</div>
                    <div class="dialog-guige-left-num">{{ item.min_buy_num }}{{ item.unit }}起批</div>
                </div>
                <div class="dialog-guige-right">
                    <el-input-number v-model="item.num" @change="handleChange(item)" :disabled="!item.checked"
                        :min="item.min_buy_num" :max="9999" label="0"></el-input-number>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
                <div class="dialogPrice">
                    总价格：<span class="totalPrice">￥{{ totalPrice }}</span>
                </div>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 导入头部组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import { ensureGoEasyConnected } from '@/utils/goeasy'
export default {
    name: 'ShopDetails',
    components: {
        // 注册头部组件
        Header,
        // 注册底部组件
        Footer
    },
    data() {
        return {
            activeTab: 'details',
            commentRating: 3,
            dialogVisible: false,
            num: 0,
            totalPrice: 0,
            shopInfo: {
                shop_info: {}
            },
            commentTabs: [],
            url: '',
            pingjiaTabs: 0,
            type_name: '',
            commentList: [],
            selectedSkus: [], // 存储选中的商品

            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,
        }
    },
    mounted() {
        this.getShopInfo()
        this.getCommentTabs()
    },
    methods: {
        handleCheckboxChange(item) {

            // 检查是否已经在数组中
            const index = this.selectedSkus.findIndex(sku => sku.key_name === item.key_name);

            if (item.checked && index === -1) {
                // 如果勾选且不在数组中，添加到数组
                this.selectedSkus.push(item);
            } else if (!item.checked && index !== -1) {
                // 如果取消勾选且在数组中，从数组中移除
                this.selectedSkus.splice(index, 1);
            }

            // 重新计算总价
            this.handleChange();
        },
        handleChange(item) {
            // 只计算选中商品的总价
            this.totalPrice = this.selectedSkus.reduce((total, item) => {
                if (item.num > 0) {
                    return total + (item.num * item.shop_price);
                }
                return total;
            }, 0);
        },
        handleClose() {
            this.dialogVisible = false
        },
        // 获取详情
        getShopInfo() {
            this.$api.getProductInfo({
                goods_id: this.$route.query.id
            }).then(res => {
                this.shopInfo = res
                this.url = this.shopInfo.images[0]
                // 处理一下sku_list
                this.shopInfo.sku_list.forEach(item => {
                    item.num = item.min_buy_num
                    item.checked = false // 初始化勾选状态为未选中
                })
                this.selectedSkus = [] // 清空选中数组
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取评价列表tabs
        getCommentTabs() {
            this.$api.getCommentTabs({
                goods_id: this.$route.query.id
            }).then(res => {
                this.commentTabs = res
                this.getCommentList()

            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取评价列表
        getCommentList() {
            this.$api.getCommentList({
                goods_id: this.$route.query.id,
                star_type: this.type_name,
                page: this.currentPage,
                list_rows: this.pageSize,
            }).then(res => {
                this.commentList = res.data
                this.totalOrders = res.total

            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 切换评价列表tabs
        changeTab(type_name, index) {
            this.pingjiaTabs = index
            this.type_name = type_name
            this.getCommentList()
        },

        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCommentList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCommentList();
        },


        // 收藏、取消收藏
        collectFn(type) {
            this.$dapi.collectShop({
                goods_id: this.$route.query.id,
            }).then(res => {
                if (type == 1) {
                    this.$message({
                        message: '收藏成功',
                        type: 'success'
                    })
                    this.shopInfo.is_collect = 1
                } else {
                    this.$message({
                        message: '取消收藏',
                        type: 'success'
                    })
                    this.shopInfo.is_collect = 0
                }
            }).catch(err => {
                this.$message.error(err);
            })

        },

        // 关注店铺
        guanzhuFn() {
            this.$dapi.guanzhuShop({
                shop_id: this.shopInfo.shop_info.store_id,
            }).then(res => {
                this.$message({
                    message: '关注成功',
                    type: 'success'
                })
                this.shopInfo.shop_info.is_attent = 1
            }).catch(err => {
                this.$message.error(err);
            })
        },
        // 取消关注店铺
        cancleGuanzhuFn() {
            this.$dapi.cancleGuanzhuShop({
                shop_id: this.shopInfo.shop_info.store_id,
            }).then(res => {
                this.$message({
                    message: '取消关注成功',
                    type: 'success'
                })
                this.shopInfo.shop_info.is_attent = 0
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 分享
        copyCurrentUrl() {
            const url = window.location.href
            const input = document.createElement('input')
            input.value = url
            document.body.appendChild(input)
            input.select()
            document.execCommand('copy')
            document.body.removeChild(input)
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },


        handleSubmit() {
            if (this.selectedSkus.length === 0) {
                this.$message({ message: '请选择规格', type: 'warning' });
                return;
            }

            this.selectedSkus.forEach(item => {
                item.totalMoney = Number(item.num) * Number(item.shop_price)
            })

            this.$router.push({
                name: 'purchase', // 用 name 跳转，而非 path
                params: {
                    id: this.$route.query.id,
                    totalPrice: this.totalPrice,
                    selectedSkus: this.selectedSkus // 直接传对象/数组
                },
                // 如需保留 query 参数，可加 query
                query: { id: this.$route.query.id }
            });
            this.dialogVisible = false;
        },


        // 在线沟通：跳转到聊天页与商家新建/打开对话
        goChat() {
            if (!this.$store.getters.isLoggedIn) {
                this.$message.warning('请先登录')
                this.$router.push('/login')
                return
            }
            const shopInfo = this.shopInfo.shop_info || {}
            const toUserId = shopInfo.user_id
            if (!toUserId) {
                this.$message.warning('未获取到商家信息')
                return
            }
            const user = this.$store.getters.getUserInfo
            ensureGoEasyConnected(user).then((connected) => {
                if (!connected) {
                    this.$message.error('聊天连接失败，请稍后重试')
                    return
                }
                this.$router.push({
                    name: 'message',
                    query: {
                        toUserId: String(toUserId),
                        toName: shopInfo.store_name || '',
                        toAvatar: shopInfo.store_logo || ''
                    }
                })
            })
        },
        // 跳转店铺详情页
        toStoreDetails(store_id) {
            this.$router.push({
                name: 'StoreDetails',
                query: {
                    id: store_id
                }
            })
        },
    }
}
</script>

<style scoped>
.shop-details-page {
    background-color: #f5f5f5;
    min-height: 100vh;
}

.container {
    width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
}

.tab-container {
    background-color: #fff;
    padding: 24px;
}

/* 面包屑导航 */
.breadcrumb {
    padding: 24px 0 20px 0;
    width: 1200px;
    margin: 0 auto;
}

/* 商品信息主体 */
.shop-details-main {
    padding: 20px 0;
}

.main-content {
    display: flex;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

/* 左侧图片区域 */
.left-section {
    width: 350px;
    padding: 20px;
    border-right: 1px solid #e8e8e8;
}

.main-image {
    width: 310px;
    height: 310px;
    border: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    overflow: hidden;
}

.main-image img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
}

.thumbnail-list {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    overflow-x: auto;
}

.thumbnail-item {
    width: 50px;
    height: 50px;
    border: 2px solid transparent;
    cursor: pointer;
    overflow: hidden;
    transition: border-color 0.3s;
}

.thumbnail-item.active {
    border-color: #286ced;
}

.thumbnail-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-actions {
    display: flex;
    gap: 15px;
    justify-content: left;
}

/* 中间商品信息区域 */
.middle-section {
    flex: 1;
    padding: 20px 30px;
    border-right: 1px solid #e8e8e8;
    text-align: left;
}

/* 标题区域 */
.title-section {
    margin-bottom: 15px;
}

.product-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    line-height: 1.4;
}

.product-subtitle {
    font-size: 14px;
    color: #666;
    line-height: 1.4;
}

/* 价格区域 */
.price-section {
    margin-bottom: 15px;
    padding: 10px 0;
    border-bottom: 1px dashed #eee;
}

.price-label {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
}

.price-value {
    font-size: 32px;
    font-weight: 700;
    color: #FF0000;
}

/* 信息行 */
.info-row {
    display: flex;
    gap: 30px;
    margin-bottom: 20px;
    padding: 10px 0;
    border-bottom: 1px dashed #eee;
}

.info-label {
    font-size: 14px;
    color: #666;
    margin-right: 8px;
}

.info-value {
    font-size: 14px;
    color: #333;
}

/* 规格选择 */
.specification {
    margin-bottom: 25px;
}

.spec-label {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
    display: block;
}

.spec-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.spec-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px dashed #eee;
    font-size: 14px;
}

.spec-name {
    color: #333;
    min-width: 80px;
}

.spec-price {
    color: #FF0000;
    font-weight: 500;
    flex: 1;
    text-align: center;
}

.spec-min {
    font-size: 12px;
    color: #999;
}

/* 购买按钮 */
.purchase-buttons {
    display: flex;
    gap: 15px;
}

.buy-button {
    width: 150px;
    height: 45px;
    background-color: #286ced;
    border-color: #286ced;
    font-size: 16px;
    border-radius: 4px;
}

.contact-button {
    width: 150px;
    height: 45px;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid #286ced;
    color: #286ced;
    background-color: #fff;
}

.contact-button:hover {
    background-color: #f0f4ff;
}

/* 右侧商家信息区域 */
.right-section {
    width: 230px;
    padding: 20px;
}

.merchant-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.merchant-logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 10px;
    border: 2px solid #f0f0f0;
}

.merchant-logo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.merchant-name {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
}

.merchant-rating {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 5px;
}

.merchant-rating .el-rate {
    margin-bottom: 5px;
}

.rating-text {
    font-size: 12px;
    color: #999;
}

.merchant-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}

.enter-shop,
.follow-shop {
    width: 100%;
    height: 36px;
    font-size: 14px;
    border-radius: 4px;
}

.enter-shop {
    border: 1px solid #2563E5;
    background-color: #fff;
    color: #2563E5;
}

.enter-shop:hover {
    background-color: #fafafa;
}

.follow-shop {
    background-color: #286ced;
    border-color: #286ced;
    margin-left: 0px !important;
}

/* 商品详情标签页 */
.product-details-tabs {
    padding: 20px 0;
    margin-top: 20px;
}

.details-tabs {
    border-bottom: 1px solid #e8e8e8;
}

.details-tabs .el-tabs__header {
    margin-bottom: 20px;
}

.details-tabs .el-tabs__nav-wrap::after {
    height: 0;
}

.details-tabs .el-tabs__nav {
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
}

.details-tabs .el-tabs__item {
    padding: 15px 30px;
    font-size: 16px;
    color: #666;
}

.details-tabs .el-tabs__item.is-active {
    color: #286ced;
    border-bottom: 2px solid #286ced;
}

/* .tab-content {
    padding: 20px 0;
} */

.tab-content h3 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
}

.details-content {
    font-size: 14px;
    color: #666;
    line-height: 2;
}

.details-image {
    margin-top: 20px;
    text-align: center;
}

.details-image img {
    max-width: 100%;
    height: auto;
}

/* 评价筛选栏样式 */
.comments-filter {
    display: flex;
    gap: 15px;
    padding: 15px 0;
    margin-bottom: 20px;
}

.filter-item {
    padding: 5px 15px;
    background-color: #f5f5f5;
    border-radius: 1px 1px 1px 1px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    transition: all 0.3s;
}

.filter-item.active {
    color: #286CED;
    background: rgba(44, 117, 244, 0.12);
    border-radius: 1px 1px 1px 1px;
    border: 1px solid #286CED;
}

.filter-count {
    margin-left: 5px;
    font-size: 12px;
}

/* 评价列表样式 */
.comment-item {
    padding: 20px 0;
    border-bottom: 1px solid #e8e8e8;
    text-align: left;
}

.comment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 10px;
}

.user-avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
}

.user-name {
    font-size: 14px;
    color: #333;
}

.comment-time {
    font-size: 12px;
    color: #999;
}

.comment-content {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    margin-bottom: 10px;
}

.comment-images {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
}

.comment-image-item {
    width: 100px;
    height: 100px;
    overflow: hidden;
    border-radius: 4px;
}

.comment-image-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.comment-spec {
    font-size: 12px;
    color: #999;
}

.comment-spec-stars {
    font-size: 12px;
    color: #999;
    margin-left: 20px;
}

.comment-spec-rating {
    display: flex;
    align-items: center;
}

.comment-rating {
    /* margin-top: 10px; */
    display: flex;
    align-items: center;
}

::v-deep .el-dialog__header {
    font-weight: 800;
}

.dialog-content {
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
}

.dialog-content-top {
    display: flex;
}

.dialog-content-top img {
    width: 88px;
    height: 88px;
}

.dialog-content-top span {
    font-size: 14px;
    color: #333333;
    line-height: 24px;
    text-align: left;
    margin-left: 16px;
}

.dialog-guige {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px dashed #e8e8e8;
}

.dialog-guige-left {
    /* display: flex;
    justify-content: space-between; */
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    font-weight: 500;
    font-size: 12px;
    color: #333333;
    width: 100%;
}

.dialog-guige-left-checkbox {
    display: flex;
    justify-content: left;
    align-items: center;
}

.dialog-guige-left-name {
    text-align: left;
    margin-left: 10px;
}

.dialog-guige-left-price {
    font-weight: 500;
    font-size: 12px;
    color: #F02325;
}

.dialog-guige-left-num {
    text-align: center;
}

.dialog-guige-right {
    margin-left: 48px;
}

.el-input-number {
    width: 140px;
}

.dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dialog-footer button {
    width: 96px;
    height: 36px;
    background: #286CED;
    border-radius: 2px 2px 2px 2px;
}

.dialogPrice {
    font-weight: 500;
    font-size: 14px;
    color: #666666;
}

.totalPrice {
    font-weight: 800;
    font-size: 20px;
    color: #F02325;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}

/* 响应式设计 */
@media (max-width: 1200px) {
    .container {
        width: 100%;
    }
}

@media (max-width: 992px) {
    .main-content {
        flex-direction: column;
    }

    .left-section,
    .middle-section,
    .right-section {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #e8e8e8;
    }

    .right-section {
        border-bottom: none;
    }
}

@media (max-width: 768px) {
    .product-title {
        font-size: 18px;
    }

    .price-value {
        font-size: 24px;
    }

    .info-row {
        flex-direction: column;
        gap: 10px;
    }

    .purchase-buttons {
        flex-direction: column;
    }

    .buy-button,
    .contact-button {
        width: 100%;
    }

    .comments-filter {
        flex-wrap: wrap;
    }

    .comment-images {
        flex-wrap: wrap;
    }
}
</style>